export const CUSTOMER_LIST_PATH = '/insure/internal/customers'

// Keyed per user: staff share machines, and one account's search restoring under another reads as a broken list.
function storageKey(userId: string): string {
  return `customers-list-filters:${userId}`
}

/** Remembers the customers list's search/owner/status/page, so the way back off a customer lands on it. */
export function setStoredCustomerListFilters(userId: string | undefined, search: string): void {
  if (!userId) return
  window.localStorage.setItem(storageKey(userId), search)
}

export function customerListHref(userId: string | undefined): string {
  const stored = userId && window.localStorage.getItem(storageKey(userId))
  return stored ? `${CUSTOMER_LIST_PATH}?${stored}` : CUSTOMER_LIST_PATH
}
